import {Typography, withStyles} from '@material-ui/core';
import Checkbox from "@components/common/checkbox/checkbox.component";
import * as React from "react";
import TranslateNew from '@translate/TranslateNew';
import {connect} from "react-redux";
import Button from "@components/common/button/Button";
import * as UserActions from '@services/user/user.actions';
import {IUser} from "@app-types/api/user.types";
import {WithStyles} from "@material-ui/core/styles";
import ProgressBar from "@components/common/progressBar/progressBar";
import cordovaContext from "../../../../cordovaContext";
import { SpecialOfferStyles } from "@components/onboarding/steps/StepSpecialOffer/specialoffer.styles";


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof SpecialOfferStyles> {
    nextStep: (customStep?: number) => void;
    progress?: number | undefined;
    claimSpecialOffer: () => void;
}

interface IState {
    acceptOffer:boolean;
}

class SpecialOffer extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            acceptOffer:true,
        };
    }

    public render() {
        const {classes: style} = this.props;
        const {acceptOffer} = this.state;

        return (<div className={style.root}>
            <div className={style.background}>
                <div className={style.circle}/>
            </div>
            <div className={style.container}>
                {this.props.progress && (<div className={style.topBar}>
                    <ProgressBar value={this.props.progress}/>
                </div>)}
                <div className={style.topContent}>
                    <Typography variant="h2">{"Specialerbjudande"}</Typography>
                    <Typography>
                        {"I ett pilotprojekt tillsammans med din"
                        +" kommun erbjuds appen gratis i 12 månader i utbyte mot att du svarar på en anonym enkät om appen."}
                    </Typography>
                </div>
                <div className={style.form} >
                    <Checkbox
                        name="acceptOffer"
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label={"Jag vill ta del av erbjudandet"}
                        checked={acceptOffer}
                        onChange={() => this.setState({acceptOffer:!acceptOffer})}
                    />
                </div>
                <div className={style.formBottomContent}>
                    <Button
                        onClick={() => this.handleSubmit()}
                        variant='contained'
                        color='primary'
                        size="large"
                        fullWidth={true}
                    >
                        {tn.lang.continue}
                    </Button>
                </div>
            </div>
        </div>);
    }


    private handleSubmit = () => {
        if(this.state.acceptOffer) {
            this.props.claimSpecialOffer();
        }
        
        this.props.nextStep();
    }
}



SpecialOffer.contextType = cordovaContext;

export default withStyles(SpecialOfferStyles)(SpecialOffer);



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepSpecialOffer/specialoffer.component.tsx